import { DotsThreeVertical, Key } from "@phosphor-icons/react";

import CopiableTag from "common/components/CopiableTag";
import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import Skeleton from "common/components/ui/Skeleton";

import useMasterApiToken from "../../datahooks/useMasterApiToken";
import useMasterApiTokenMutations from "../../datahooks/useMasterApiTokenMutations";

export default function MasterApiKey() {
  const { masterApiToken, isLoadingMasterApiToken } = useMasterApiToken();
  const { createMasterApiToken, isCreatingMasterApiToken } =
    useMasterApiTokenMutations();

  return (
    <div className="flex flex-col border-purple-50 bg-purple-50/30 border rounded-3xl">
      <p className="px-3 py-2.5 text-purple-500 text-xs-medium">
        The Master API key is owner exclusive. It can manage all workspaces, and
        is used to set up white label integrations
      </p>
      <table className="border-separate border-spacing-0 bg-white rounded-3xl -mx-px -mb-px">
        <tbody>
          <tr>
            <td className="p-3 border-l rounded-l-3xl border-y  border-black-200 text-sm-bold w-64">
              Master API key
            </td>
            <td className="p-3 border-y border-black-200 text-button-xs text-left w-32">
              <RenderIf condition={!!masterApiToken}>All permissions</RenderIf>
            </td>
            <td className="p-3 border-y border-black-200 text-left w-52">
              {isLoadingMasterApiToken ? (
                <Skeleton className="w-32 h-6" />
              ) : (
                <RenderIf condition={!!masterApiToken}>
                  <CopiableTag value={masterApiToken} />
                </RenderIf>
              )}
            </td>
            <td className="p-3 border-y border-black-200 text-left">
              <RenderIf condition={!!masterApiToken}>-</RenderIf>
            </td>
            <td className="p-3 border-r rounded-r-3xl border-y  border-black-200 text-right">
              {masterApiToken ? (
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      intent="iconOnly"
                      size="sm"
                      variant="secondary-black"
                      isLoading={isCreatingMasterApiToken}
                    >
                      <DotsThreeVertical />
                    </Button>
                  </DropdownMenuTrigger>

                  <DropdownMenuContent align="end" size="sm">
                    <DropdownMenuList>
                      <DropdownMenuItem onSelect={() => createMasterApiToken()}>
                        <Key weight="fill" />
                        Re-generate key
                      </DropdownMenuItem>
                    </DropdownMenuList>
                  </DropdownMenuContent>
                </DropdownMenu>
              ) : (
                <Button
                  onClick={() => createMasterApiToken()}
                  leftIcon={<Key weight="fill" />}
                  size="sm"
                  variant="secondary-black"
                  isLoading={isCreatingMasterApiToken}
                >
                  Generate key
                </Button>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
